var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenEarly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.9,24.61A1.17,1.17,0,0,1,2,24.23c-.16-.22,0-.62,0-.85l.26-.56a12.18,12.18,0,0,1,1.54-2.41,1.29,1.29,0,0,1,1.52-.25,5.12,5.12,0,0,1,.71.6,2.36,2.36,0,0,0,1.49.51H8a2.39,2.39,0,0,0,1.54-.5,5,5,0,0,1,.7-.6,1.19,1.19,0,0,1,1.39.25,9.6,9.6,0,0,1,1.45,2.45l.27.55a1,1,0,0,1,.08.85,1.1,1.1,0,0,1-.93.3Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.08,16.29a3.45,3.45,0,0,0,3.24-3.64v-.07a3.34,3.34,0,0,0-3.24-3.42H16a3.33,3.33,0,0,0-3.18,3.49v0A3.46,3.46,0,0,0,16.08,16.29Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74,19.63A3.46,3.46,0,0,0,11,16h0a3.33,3.33,0,0,0-3.15-3.52H7.74A3.34,3.34,0,0,0,4.52,15.9s0,.06,0,.09h0A3.45,3.45,0,0,0,7.74,19.63Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.28,13.08a3.54,3.54,0,0,0,3.25-3.64V9.37A3.33,3.33,0,0,0,24.28,6h0A3.31,3.31,0,0,0,21.11,9.4h0a3.53,3.53,0,0,0,3.23,3.68Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,17.05a1.19,1.19,0,0,0-1.34-.21,4,4,0,0,0-.71.59,2.44,2.44,0,0,1-1.54.51h-.49a2.43,2.43,0,0,1-1.56-.52,6.62,6.62,0,0,0-.7-.59,1.26,1.26,0,0,0-1.51.23,11.25,11.25,0,0,0-1.59,2.46l-.1.22a1.55,1.55,0,0,1,1.54.45,12.85,12.85,0,0,1,.76,1.06h5.58A5.89,5.89,0,0,1,20,17.05Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.24,16.7a5.93,5.93,0,0,1,4-1.48h0A6,6,0,0,1,29.27,18,1.09,1.09,0,0,0,30,17.7a1.08,1.08,0,0,0-.07-.86l-.28-.53a9.94,9.94,0,0,0-1.48-2.46,1.17,1.17,0,0,0-1.4-.23,3.54,3.54,0,0,0-.7.59,2.41,2.41,0,0,1-1.51.5h-.49a2.32,2.32,0,0,1-1.56-.52,3.71,3.71,0,0,0-.69-.55,1.25,1.25,0,0,0-1.51.24A11,11,0,0,0,18.8,16.3v.06A1.66,1.66,0,0,1,20.24,16.7Z",
    style: {
      fill: "#00a6e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.21,16.41A4.82,4.82,0,1,0,29,21.23h0A4.83,4.83,0,0,0,24.21,16.41Zm0,8.5a3.7,3.7,0,1,1,3.7-3.69h0a3.68,3.68,0,0,1-3.67,3.69Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.54 20.94 24.54 18.68 23.41 18.68 23.41 22.07 24.54 22.07 26.81 22.07 26.81 20.94 24.54 20.94",
    style: {
      fill: "#7c7c7c"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEarly);
export default __webpack_public_path__ + "static/media/open-early.f1c7938c.svg";
export { ForwardRef as ReactComponent };